<template>
  <div :class="`comp-table-inner-edit ${data.fieldType == 25 ? 'table-inner-edit-association' : ''}`" v-if="data.editable" ref="tableInnerEditRef">
    <!-- 计算状态 1 3 当前数据状态不支持编辑 这种不能编辑(走审批且状态审批中/已生效) -->
    <template v-if="computingStatus.includes(Number(configParams.computedInfo?.status)) || (configParams.row.lockedOrigin && data.entity != 101) || (getFieldExtUploadType()?.uploadType == 2 && getFieldExtUploadType()?.fileType == 2)">
      <span class="table-inner-edit-icon" @click.stop="">
        <jw-tooltip content="当前数据状态不支持编辑" :content-style="{ borderRadius: '4px' }"> <icon-pen-fill /> </jw-tooltip>
      </span>
    </template>
    <template v-else>
      <!-- EntityType 特殊处理 -->
      <template v-if="data.fieldKey != 'entityType'">
        <template v-if="configParams.permissions && configParams.permissions == 1 && userInfo?.roles?.indexOf(data.permissionsObjList[data.entity]) !== -1">
          <span class="table-inner-edit-icon table-inner-edit-permissions" @click.stop="clickEdit">
            <icon-pen-fill />
          </span>
        </template>
        <template v-else>
          <span class="table-inner-edit-icon" @click.stop="">
            <jw-tooltip content="你没有权限编辑此字段" :content-style="{ borderRadius: '4px' }"> <icon-pen-fill /> </jw-tooltip>
          </span>
        </template>
      </template>
    </template>
  </div>

  <template v-if="data.editContent">
    <!--不走行内编辑 -->
    <template v-if="data.NoLineEditable.indexOf(data.fieldType) > -1">
      <div class="not-inner-edit">
        <!-- 附件 -->
        <template v-if="data.fieldType === 18">
          <fh-upload-modal @cb="getNewFieldsVal" ref="uploadRef" opType="0" />
        </template>
        <!-- 人员 -->
        <template v-if="data.fieldType === 6">
          <!-- {{ getEditFieldsObj.fieldValue?.join('') }} -->
          <div class="inner-tag">
            <xl-tree-member-modal v-show="false" :tree="personTree" :memberNumber="1" ref="xlTreeMember" :multipleDep="tools.isJSON(data.fieldExt) ? (JSON.parse(data.fieldExt)?.single == 1 ? false : true) : true" @cb="getMember($event)" :user="data.getOriginalValue.userList" @cancel="closeEdit">
              <jw-input-tag v-model="getEditFieldsObj.fieldValue" class="system-form-person-value" :max-tag-count="3" readonly placeholder="请选择" />
            </xl-tree-member-modal>
          </div>
        </template>
        <!-- 部门-->
        <template v-if="data.fieldType === 22">
          <!-- {{ getEditFieldsObj.fieldValue?.join('') }} -->
          <div class="inner-tag">
            <xl-tree-member-modal v-show="false" ref="xlTreeMember" :tree="departTree" :multipleDep="data.fieldExt == 1 ? false : true" :depart="data.getOriginalValue.departList" @cb="getMember($event)" @cancel="closeEdit">
              <jw-input-tag v-model="getEditFieldsObj.fieldValue" class="system-form-person-value" :max-tag-count="3" readonly placeholder="请选择" />
            </xl-tree-member-modal>
          </div>
        </template>

        <template v-if="data.fieldType === 26">
          <!-- 富文本 -->
          <ly-editor-dialog ref="editorDialogRef" @cb="handelEditorCb" :isRequired="data.isRequired"></ly-editor-dialog>
        </template>
      </div>
    </template>
    <!-- 走行内编辑 -->
    <template v-else>
      <!-- 主列表 -->
      <teleport to="body" v-if="data.isList">
        <quick-edit-content :fieldInfo="props.configParams.col" ref="tableInnerEditContentRef" @cb="getNewFieldsVal" @closeModal="closeModal" @cancelEdit="closeEdit" :editFieldsObj="getEditFieldsObj" />
      </teleport>
      <!-- 详情和关联对象表格 -->
      <template v-else>
        <quick-edit-content :fieldInfo="props.configParams.col" ref="tableInnerEditContentRef" @cb="getNewFieldsVal" @closeModal="closeModal" @cancelEdit="closeEdit" :editFieldsObj="getEditFieldsObj" :zIndex="data.zIndex" />
      </template>
    </template>
  </template>
  <template v-if="data.showOverlay">
    <!-- 主列表 -->
    <teleport to="body" v-if="data.isList">
      <div class="overlay" @click.stop="hideLay"></div>
    </teleport>
    <!-- 详情及关联表格 -->
    <div v-else class="overlay" :style="{ zIndex: data.zIndex }" @click.stop="hideLay"></div>
  </template>
</template>

<script setup>
import { ref, reactive, nextTick, inject, computed } from 'vue';
import useViewFields from '@/hooks/view-fields';
import useEditFields from '@/hooks/edit-field';
import md5 from 'js-md5';
import CONFIG from '@/config/config';
import { useUserStore } from '@/store';
import { tools } from '@/utils/tools.js';
import dayjs from 'dayjs';
import { Message } from '@arco-design/web-vue';
import { objectRoleEnum, computingStatus } from '@/utils/const'; //对象的key合集
import QuickEditContent from './components/quick-Edit-content/quick-Edit-content.vue'; //表格内编辑组件内容（新）

const { getFieldValue, getFieldLabel } = useViewFields();
const { editField } = useEditFields();
const emits = defineEmits(['cb']);
const props = defineProps({
  configParams: {
    type: Object,
    default: () => {}
  }
});
const fieldEditMethods = inject('fieldEditMethods'); //调用父组件方法
const getEditFlag = //记录编辑状态
  fieldEditMethods?.getEditFlag ||
  (() => {
    return '';
  });

const updateEditShow = //编辑之后把编辑状态恢复
  fieldEditMethods?.updateEditShow ||
  (() => {
    return '';
  });
const ps = computed(() => props?.configParams);
const psc = ref(ps.value?.col);
const data = reactive({
  refreshValue: inject('detailParams')?.refreshValue,
  entity: ps.value?.entity || '', //对象
  businessId: ps.value?.row?.id || '', //数据id
  fieldKey: psc.value?.fieldKey,
  fieldName: psc.value?.fieldName,
  fieldExt: ps.value?.fieldExt,
  fieldType: ps.value?.fieldType,
  isRequired: psc.value?.isRequired,
  isList: ps.value?.isList, //是否是列表
  isSubForm: ps.value?.isSubForm, //是否是子表
  associationTable: ps.value?.associationTable, //是否是关联表格
  isDetail: ps.value?.isDetail, //是否是详情
  subEntityId: ps.value?.subEntityId, //子表的entity
  uniqueValue: ps.value?.uniqueValue, //当前字段的唯一值
  columns: inject('globalParams')?.columns || inject('defaultParams')?.columns,

  editable: true, //编辑状态
  editContent: false, //编辑容器
  showOverlay: false, //蒙层
  specialProduct: [7, 9, 11, 14, 32], //特殊产品对象
  permissionsObjList: {
    //编辑权限
  },

  selectList: [2, 3, 4, 5], //单选多选
  NoLineEditable: [6, 18, 22, 26], //不走行内编辑的字段类型
  getOriginalValue: {
    userList: [], //人员列表
    departList: [], //部门列表
    userIds: [], //人员ids
    departIds: [] //部门ids
  },
  zIndex: 1001 //默认是1001
});
const getFieldExtUploadType = () => {
  if (data.fieldExt && tools.isJSON(data.fieldExt) && JSON.parse(data.fieldExt)) {
    return JSON.parse(data.fieldExt);
  }
};

const getEditFieldsObj = ref({});
const editorDialogRef = ref(null);
for (const key in objectRoleEnum) {
  if (!data.specialProduct.includes(Number(key))) {
    data.permissionsObjList[key] = objectRoleEnum[key] + ':edit';
  }
}

//兼容自定义
if (data.entity >= 200) {
  data.permissionsObjList[data.entity] = `${data.entity}:edit`;
}

const { userInfo } = useUserStore(); //用户信息
const tableInnerEditContentRef = ref(); //编辑内容分类组件
const newFieldValue = ref(props.configParams.fieldValue);
const newOriginalValue = ref(); //数据原值
// 人员组件参数
const personTree = ref({
  checkDepartment: false
});
//部门组件参数
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
const storage = {
  getItem(key) {
    let v = localStorage.getItem(key);
    if (v !== 'null' && v !== undefined) {
      v = JSON.parse(v);
    }
    return v;
  }
};
const uuid = ref(inject('defaultParams')?.viewId);
const tableInnerEditRef = ref(null);
const getEditFieldValue = ref();

const setFieldExt = ref();
const getFieldExt = ref();
const uploadRef = ref(); //上传附件
const xlTreeMember = ref(); //人员//部门

const ids = ref();
const memberlist = ref();

// 人员/组件获取
const getMember = async (v) => {
  ids.value = data.fieldType === 6 ? v.userList?.map((u) => u.id)?.join(',') || '' : v.departList?.map((u) => u.id)?.join(',') || '';
  memberlist.value = data.fieldType === 6 ? v?.userList || [] : v?.departList || [];
  if (data.isRequired && memberlist.value?.length == 0) {
    //必填校验
    Message.warning('必填字段不能为空!');
    closeEdit();
    return;
  }
  try {
    emits('cb', {
      fieldValue: memberlist.value,
      businessId: data.businessId
    });
    const params = {
      fieldValue: ids.value,
      entity: data.isSubForm ? data.subEntityId : data.entity,
      fieldKey: data.fieldKey,
      businessId: data.businessId,
      apiIndex: data.entity + data.fieldKey + data.businessId
    };
    await editField(params);
    Message.success('保存成功');
    closeEdit();
  } catch (error) {
    console.error('Error in getMember:', error);
    Message.error('保存失败');
  }
};

const editorVal = ref('');
const handelEditorCb = async (val) => {
  //富文本确定
  if (val.type === 'ok') {
    editorVal.value = val.value;
    console.log(data.isRequired, val, 'console.log(data.isRequired, val');
    if (data.isRequired && (val.value == '' || val.value == '<p><br></p>')) {
      //必填校验
      Message.warning('必填字段不能为空!');
      closeEdit();
      return;
    }
    await saveVal();
    // closeEdit();
  } else {
    getNewFieldsVal({ fieldValue: props.configParams.fieldValue });
    closeEdit();
  }
};
// 富文本点击保存
const saveVal = async () => {
  const params = {
    entity: data.isSubForm ? data.subEntityId : data.entity,
    fieldKey: data.fieldKey,
    businessId: data.businessId,
    apiIndex: data.entity + data.fieldKey + data.businessId
  };
  if (data.fieldType === 6 || data.fieldType === 22) {
    params.fieldValue = ids.value;
  }

  if (data.fieldType === 26) {
    // 富文本特殊处理
    params.fieldValue = editorVal.value;
  }
  const setParams = editorVal.value;
  emits('cb', {
    fieldValue: setParams.fieldValue,
    businessId: data.businessId
  });

  const getResult = await editField(params);
  if (!getResult.error) {
    Message.success('保存成功');
    updateEditShow();
  } else {
    console.log('保存失败');
  }
};
const clickEdit = () => {
  //点击编辑

  newOriginalValue.value = props.configParams.fieldValue; //获取最新数据原值
  const getAditPopup = document.querySelectorAll('.obj-details-drawer');
  if (getAditPopup && getAditPopup?.length > 0) {
    data.zIndex = Number(getAditPopup[getAditPopup?.length - 1].style.zIndex) + 1;
  }
  if (data.fieldExt && tools.isJSON(data.fieldExt) && (data.selectList.indexOf(data.fieldType) > -1 || data.fieldType == 10)) {
    //把已经禁用的选项过滤掉
    setFieldExt.value = JSON.stringify(JSON.parse(data.fieldExt)?.filter((i) => i.isEnabled));
    getFieldExt.value = setFieldExt.value && tools.isJSON(setFieldExt.value) ? JSON.parse(setFieldExt.value) : [];
  }
  if (data.selectList.indexOf(data.fieldType) > -1 || data.fieldType == 10) {
    //多选,级联
    const editFieldValue = newFieldValue.value && getFieldValue(newFieldValue.value, data.fieldExt, data.fieldType); //根据字段的label获取value
    // console.log('editFieldValue---', editFieldValue);
    if (data.fieldType === 3 || data.fieldType === 5) {
      //多选/下拉多选特殊处理
      getEditFieldValue.value = (editFieldValue && editFieldValue?.split('/')) || [];
      const valuesInAa = new Set(getFieldExt.value?.map((item) => item.value)); //把value过滤出来
      const filteredBb = getEditFieldValue.value?.filter((value) => valuesInAa.has(value));
      getEditFieldValue.value = filteredBb && filteredBb?.length > 0 ? filteredBb : ''; //把在fieldExt里不存在的选项值清空
    } else if (data.fieldType === 2 || data.fieldType === 4) {
      //单选/下拉单选特殊处理
      getEditFieldValue.value = editFieldValue || '';
      const findOption = getFieldExt.value?.find((el) => el.value == getEditFieldValue.value);
      if (!findOption) {
        //在fieldExt里没有获取到把值清空
        getEditFieldValue.value = '';
      }
    } else {
      //级联
      getEditFieldValue.value = editFieldValue && typeof editFieldValue === 'string' ? editFieldValue?.split('/') : [];
    }
  } else if (data.fieldType == 8) {
    //日期
    if (newFieldValue.value) {
      // const fe = isShowTime(data?.fieldExt) ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
      getEditFieldValue.value = dayjs(newFieldValue.value).format(data?.fieldExt);
    } else {
      getEditFieldValue.value = '';
    }
  } else if (data.fieldType == 9) {
    //日期
    getEditFieldValue.value = newFieldValue.value && typeof newFieldValue.value === 'string' ? newFieldValue.value?.split('/') : [];
  } else if (data.fieldType == 7) {
    //数字类型的
    getEditFieldValue.value = !isNaN(parseFloat(newFieldValue.value)) ? Number(newFieldValue.value) : '';
  } else if (data.fieldType == 6) {
    //人员
    data.getOriginalValue.userList = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value.map((e) => ({ userName: e?.userName, id: e?.userId || e?.id, avatarOrigin: e?.avatar || e?.avatarOrigin })) : [];
    data.getOriginalValue.userIds = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value?.map((e) => e?.userId || e?.id) : '';
    getEditFieldValue.value = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value?.map((e) => e?.userName) : [];
  } else if (data.fieldType == 22) {
    //部门
    data.getOriginalValue.departList =
      newOriginalValue.value && Array.isArray(newOriginalValue.value)
        ? newOriginalValue.value?.map((u) => {
            return {
              departmentName: u?.name || u?.departmentName,
              id: u.id
            };
          })
        : [];
    data.getOriginalValue.departIds = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value?.map((u) => u.id) : '';
    getEditFieldValue.value = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value?.map((u) => u?.name || u?.departmentName) : [];
  } else if (data.fieldType == 16) {
    //金额
    getEditFieldValue.value = !isNaN(parseFloat(newOriginalValue.value)) ? tools.getPrice(newOriginalValue.value, data.fieldExt) : '';
  } else if (data.fieldType == 23) {
    //百分比

    getEditFieldValue.value = !isNaN(parseFloat(newOriginalValue.value)) ? Number(tools.getPercentage(newOriginalValue.value, data.fieldExt)) : '';
  } else {
    //其他类型
    getEditFieldValue.value = newFieldValue.value || '';
  }
  const rect = tableInnerEditRef.value?.getBoundingClientRect();
  let newWidth;
  if (data.associationTable) {
    //关联对象表格
    newWidth = data?.columns?.find((el) => el.colKey == data.fieldKey)?.width;
  }
  if (data.isList) {
    //主列表
    const uniqueKey = data?.columns?.map((el) => el.colKey).join('') + data?.columns?.length;
    // 保存默认列和实际列
    const tableKey = `${CONFIG.prefix}QF_TABLE_COLS_${uuid.value}_${md5(uniqueKey)}`;
    const kf = storage.getItem(tableKey);
    newWidth = kf?.k?.[data.fieldKey]?.width;
  }

  getEditFieldsObj.value = {
    //保存字段信息
    isList: data.isList,
    associationTable: data.associationTable,
    isDetail: data.isDetail,
    entity: data.entity,
    subEntityId: data.subEntityId,
    isSubForm: data.isSubForm,
    fieldKey: data.fieldKey,
    fieldType: data.fieldType,
    fieldExt: data.selectList.indexOf(data.fieldType) > -1 ? setFieldExt.value : data.fieldExt,
    fieldName: data.fieldName,
    fieldValue: getEditFieldValue.value,
    businessId: data.businessId,
    isRequired: data.isRequired,
    top: rect.top + window.scrollY - 4 + 'px',
    left: data.isSubForm ? rect.left + window.scrollX + 8 + 'px' : rect.left + window.scrollX - 8 + 'px',
    width: newWidth + 'px'
  };
  data.editable = false;
  data.editContent = true;
  getEditFlag();
  if (data.NoLineEditable.indexOf(data.fieldType) == -1) {
    //走行内编辑的字段类型
    data.showOverlay = true;
    nextTick(() => {
      tableInnerEditContentRef.value?.processing(); //对一些字段的默认处理
    });
  }
  nextTick(() => {
    if (data.fieldType == 18) uploadRef.value?.openModal(getEditFieldsObj.value); //编辑附件弹窗
    if (data.fieldType == 6 || data.fieldType == 22) xlTreeMember.value?.openDialog(); //人员组件
    if (data.fieldType == 26) editorDialogRef.value?.openDialog(getEditFieldsObj.value);
  });

  console.log('编辑的值，', getEditFieldsObj.value);
};

// 获取修改之后的值
const getNewFieldsVal = (cbParams) => {
  //保存人员、部门选择的原值
  //只有列表处理-日期
  // eslint-disable-next-line no-debugger
  // debugger;
  if (data.fieldType == 9) {
    newFieldValue.value = cbParams.fieldValue;
  }
  // 列表和详情都要处理的逻辑（单选，多选，级联）
  else if (data.selectList.includes(data.fieldType) || data.fieldType == 10) {
    const tempFields = getFieldLabel(cbParams.fieldValue, data.fieldExt, data.fieldType);
    // console.log('tempFields---',tempFields)
    if (data.fieldType == 2 || data.fieldType == 4) {
      //单选，下拉单选
      newFieldValue.value = tempFields ?? '';
    }
    if (data.fieldType == 3 || data.fieldType == 5) {
      //下拉多选，多选
      newFieldValue.value = Array.isArray(cbParams.fieldValue) && cbParams.fieldValue?.length > 0 ? tempFields?.split('/')?.join(',') : '';
    }
    if (data.fieldType == 10) {
      //级联
      newFieldValue.value = Array.isArray(cbParams.fieldValue) && cbParams.fieldValue?.length > 0 ? tempFields : '';
    }
  } else if (data.fieldType == 8) {
    //日期
    if (cbParams.fieldValue) {
      const fe = data.fieldExt ? data.fieldExt : cbParams.fieldValue?.split(' ')?.length > 1 ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
      newFieldValue.value = dayjs(cbParams.fieldValue).format(fe);
    } else {
      newFieldValue.value = '';
    }
  } else {
    console.log('抛出数据555', cbParams);
    newFieldValue.value = cbParams.fieldValue;
  }
  if (!data.isList && data?.refreshValue) {
    //详情刷新重复的字段值

    let refreshVal = cbParams.fieldValue;
    if (data.selectList.includes(data.fieldType) || data.fieldType == 10) {
      refreshVal = newFieldValue.value;
    }
    data?.refreshValue(refreshVal, data.fieldKey);
  }
  console.log('抛出数据666', cbParams);

  emits('cb', {
    fieldValue: newFieldValue.value,
    businessId: data.businessId
  });
  closeEdit();
};
// 隐藏遮罩
const closeModal = async () => {
  data.showOverlay = false;
};
// 关闭编辑状态
const closeEdit = () => {
  updateEditShow();
  data.editContent = false;
};
// 点击遮罩
const hideLay = async () => {
  await tableInnerEditContentRef.value?.editSave();
  closeEdit();
};
</script>
<style scoped lang="less">
@import './ly-quick-Edit.less';
</style>
